import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './alertShipmentModal.css';
import shipmentWarningModalImage from '../../../src/assets/images/shipment_warning_modal_image.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState } from 'react';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const AlertShipmentModal = ({isOpen, onClose, handlePlaceShipment}) => {
  const [open, setOpen] = React.useState(false);

  const placeShipment = () => {
    handlePlaceShipment();
  };
  const handleClose = () => {
    onClose(true);
  };

  return (
    <React.Fragment >
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        PaperProps={{
            style: {
                maxWidth: '370px', // Adjust the maxWidth as needed
                width: '100%',
                maxHeight:'360px'
            },
        }}
        maxHeight="300" // Adjust the maxHeight as needed
        
      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
              <div className='alertShipmentModalImagediv'>  
                <img 
                  className='alertShipmentModalImage'
                  src={shipmentWarningModalImage}
                />
                <h4 
                  className='headingForAlertShipmentModal'
                > Alert! </h4>
                <h4 className='subHeadingForAlertShipmentModal'>
                Data once captured cannot be edited. Please check all the details before proceeding further.
                </h4>
              </div>
              <div>
                <hr style={{width:"100%"}}>
                </hr>
              </div>
              <div >
                <Button className='goBackButton' onClick={handleClose}>Go Back to Edit</Button>
                <Button className='shipmentPlaceButton' onClick={placeShipment}>Place Shipment</Button>
              </div>
        </DialogTitle>
        
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor:"white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default AlertShipmentModal;
